import React, { Component, Fragment } from 'react';
import WatchDemo from './../modals/watchADemo'
import Header from './Header';
import Footer from './Footer';

class WhosITForPage extends Component {

    render() {

        return (
            <Fragment>
                <Header {...this.props} />
                <div className="banner-area auto-height text-center text-normal text-light shadow dark-hard bg-fixed">
                    <div className="container">
                        <div className="row">
                            <div
                                style={{ 'paddingBottom': 0 }}
                                className="content-box video-popup"
                            >
                                <div className="col-md-10 col-md-offset-1">
                                    <div className="content">
                                        <h1>
                                            Built for trainers, coaches, gyms, and fitness brands
										</h1>
                                        <p>
                                            Our software and workout app helps fitness professionals{' '}
                                            <b>increase profits</b> and{' '}
                                            <b>create recurring monthly revenue</b> by{' '}
                                            <em>
                                                <u>
                                                    <b>making it easy</b>
                                                </u>
                                            </em>{' '}
                                            to build and share original workouts in today’s digital
											word
										</p>
                                        <a
                                            className="btn circle btn-light border btn-md mar30"
                                            data-toggle="modal"
                                            data-target="#freedownload"
                                        >
                                            Try it free
										</a>
                                        <WatchDemo mrgnClass={"mar30"}></WatchDemo>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div id="overview" className="work-list-area default-padding">
                    <div className="container">
                        <h1 className="text-center">
                            Meet some of our fitness professionals
						</h1>
                        <div className="row">
                            <div className="col-md-6 thumb text-center pull-right">
                                <img src="assets/img/gym.png" width="400px" alt="" />
                            </div>
                            <div className="col-md-6 info pull-left">
                                <h3>Gyms</h3>
                                <p>
                                    "Before Fitbanx, I had no easy way to offer my members custom workouts specific to the equipment in our gym. I can upload new exercise videos with my phone in seconds and use those videos to make custom workouts.  Not only am I making more money,  but my members are better engaged because they don’t have to guess how to workout."
									<br /><br />Willie Dickson- Snap Fitness Manager
								</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    style={{ 'paddingTop': 0 }}
                    id="overview"
                    className="work-list-area default-padding"
                >
                    <div className="container">
                        <div className="row">
                            <div className="col-md-6 thumb text-center">
                                <img src="assets/img/trainer-coach.png" width="400px" alt="" />
                            </div>
                            <div className="col-md-6 info">
                                <h3>Trainers & Coaches</h3>
                                <p>
                                    "In today's digital age, people don't want to depend on YouTube videos or slow internet streaming to access workouts. My customers love Fitbanx because they can start, stop, skip, and replay exercises and workouts on their own time….it’s so easy to use and it saves me and my customers time while helping me make more money!"
									<br /><br />Leigh Bossier- Personal Trainer and D-STRONG Coach
								</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    style={{ 'paddingTop': 0 }}
                    id="overview"
                    className="work-list-area default-padding"
                >
                    <div className="container">
                        <div className="row">
                            <div className="col-md-6 thumb text-center pull-right">
                                <img src="assets/img/fitness-brand.png" width="400px" alt="" />
                            </div>
                            <div className="col-md-6 info pull-left">
                                <h3>Fitness brands</h3>
                                <p>
                                "We have a full-body workout tool which is relatively new to the market.  There are 70+ exercises that can be done with our product. Having these exercises available in a digital format like Fitbanx really makes it easy for our customers to workout anytime and anywhere. It would have cost us over $100,000 to develop our own custom app so working with Fitbanx was a no brainer!"
								<br /><br />Linglu Ma- Gym Well Marketing and Brand Specialist
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    id="features"
                    className="features-area cell-items default-padding second-page-features"
                >
                    <div className="container">
                        <h1 className="text-center">
                            Easy and affordable technology built for you
						</h1>
                        <div className="row">
                            <div className="features-items icon-solid">
                                <div className="col-md-12">
                                    <div className="items-box inc-cell">
                                        <div className="col-md-4 col-sm-4 equal-height1 text-left">
                                            <div className="item">
                                                <div className="info">
                                                    <h4>
                                                        <img width="40px" src="assets/img/writing.png" alt="Thumb" />{' '}
                                                        Customize content
													</h4>
                                                    <p>
                                                        Customize workouts and programs specific to your
														gym, location, and/or training equipment and share
														it with your customers.
													</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4 col-sm-4 equal-height1 text-left">
                                            <div className="item">
                                                <div className="info">
                                                    <h4>
                                                        <img width="40px" src="assets/img/seo.png" alt="Thumb" /> True
														digital experience
													</h4>
                                                    <p>
                                                        Most workout building apps rely on youtube videos.
														Your customers don’t have time for internet hang ups
														and slow streaming.
													</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4 col-sm-4 equal-height1 text-left">
                                            <div className="item">
                                                <div className="info">
                                                    <h4>
                                                        <img width="40px" src="assets/img/lightbulb.png" alt="Thumb" />{' '}
                                                        Easy-to-use technology
													</h4>
                                                    <p>
                                                        Simplicity is our priority. You will be amazed how
														easy it is for you to build and share workouts and
														how easy it is for your customers to access
														workouts.
													</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4 col-sm-4 equal-height1 text-left">
                                            <div className="item">
                                                <div className="info">
                                                    <h4>
                                                        <img width="40px" src="assets/img/return.png" alt="Thumb" />{' '}
                                                        Subscription income
													</h4>
                                                    <p>
                                                        Subscription income made easy (paid monthly) with
														real time analytics.
													</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4 col-sm-4 equal-height1 text-left">
                                            <div className="item">
                                                <div className="info">
                                                    <h4>
                                                        <img width="40px" src="assets/img/dollar.png" alt="Thumb" />{' '}
                                                        Referral income
													</h4>
                                                    <p>
                                                        Receive 85% of ALL Subscription revenue collected
														from ANYWHERE within Fitbanx when customers are
														referred to us by you.
													</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4 col-sm-4 equal-height1 text-left">
                                            <div className="item">
                                                <div className="info">
                                                    <h4>
                                                        <img width="40px" src="assets/img/computer.png" alt="Thumb" />{' '}
                                                        Easy business
													</h4>
                                                    <p>
                                                        We collect the money, send you the money, and
														provide all data analytics so you can focus on what
														you do best.
													</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="banner-area auto-height text-center text-normal text-light shadow dark-hard bg-fixed">
                    <div className="container">
                        <div className="row">
                            <div
                                style={{ padding: '40px 0' }}
                                className="content-box video-popup"
                            >
                                <div className="col-md-10 col-md-offset-1">
                                    <div className="content">
                                        <h2>Start building and sharing your workouts today</h2>
                                        <a
                                            className="btn circle btn-light border btn-md"
                                            data-toggle="modal"
                                            data-target="#freedownload"
                                        >
                                            Try it free
										</a>
                                        <WatchDemo></WatchDemo>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer {...this.props} />
            </Fragment>
        );
    }
}

export default WhosITForPage;



// WEBPACK FOOTER //
// ./src/components/WhosITForPage.js